import React from 'react';
import {
  addSignCommaFormat,
  commaFormat,
  getSign,
} from '../new-report/utils/formatter';

type Props = {
  brokerName: JSX.Element;
  valuation: number | null;
  quantity: number | null;
  profitOrLoss: number | null;
};

export const InvestmentTrustPositionItem = ({
  brokerName,
  profitOrLoss,
  quantity,
  valuation,
}: Props): React.ReactElement => {
  const profitOrLossColor = ((sign: ReturnType<typeof getSign>): string => {
    switch (sign) {
      case 'plus':
      case 'zero':
        return 'text-upcolor';
      case 'minus':
        return 'text-downcolor';
    }
    return 'text-upcolor';
  })(getSign(profitOrLoss ?? 0));
  return (
    <>
      <div className="flex flex-col">
        <div className="flex flex-row items-center bg-gray-300 text-bluegray-500 px-3 py-2 text-base">
          {brokerName}
        </div>
        <div className="flex flex-col px-4 py-3">
          <div className="flex flex-row justify-between items-center">
            <div className="text-base text-bluegray-500">評価額</div>
            <div className="font-bold text-lg text-bluegray-700 flex flex-row items-center">
              <div className="mr-1">
                {valuation === null
                  ? '---'
                  : commaFormat(valuation, { numberOfDecimals: 0 })}
              </div>
              <div>円</div>
            </div>
          </div>
          <div className="flex flex-row mt-1 items-center">
            <div className="flex flex-row text-base text-bluegray-700 mr-auto items-center">
              <div className="mr-1">
                {quantity === null
                  ? '---'
                  : commaFormat(quantity, { numberOfDecimals: 0 })}
              </div>
              <div>口</div>
            </div>
            <div className="flex flex-row items-center">
              <div className="text-sm text-bluegray-500 mr-4">評価損益</div>
              <div
                className={`flex ${profitOrLossColor} text-base items-center`}>
                <div className="mr-1">
                  {addSignCommaFormat(profitOrLoss, { numberOfDecimals: 0 })}
                </div>
                <div>円</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
